import { Box, CircularProgress } from '@mui/material';

import { SalaryProposalProps } from '~/data/proposals';
import {
  EmployeeProposalsLayout,
  EmployeeProposalsLayoutProps,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeProposalsLayout/component';
import { useSalaryProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeSalaryProposalsLayout/useSalaryProposalsLayout';

export const EmployeeSalaryProposalsLayout = (
  props: EmployeeProposalsLayoutProps<SalaryProposalProps>,
) => {
  const { newProposal, ...passProps } = props;
  const { isLoading, ...salaryProps } = useSalaryProposalsLayout(props);

  const layoutProps = {
    ...passProps,
    ...salaryProps,
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return <EmployeeProposalsLayout {...layoutProps} />;
};
